import { Component } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false
})
export class HeaderComponent implements OnInit {

  isAdminUser: boolean = false;
  isTenantUser: boolean = false;
  isMerchantUser: boolean = false;
  userName: string = '';
  loginType: string = '';

  constructor( private router: Router, private authService: AuthService) {
    this.isAdminUser = authService.IsAdminUser$.value;
    this.isTenantUser = authService.IsTenantUser$.value;
    this.isMerchantUser = authService.IsMerchantUser$.value;
    this.userName = localStorage.getItem('UserName') ?? '';
    this.loginType = localStorage.getItem('loginType') ?? '';
  }
    ngOnInit(): void {      
    }

  redirectToHome() {
    this.router.navigate(['/dashboard']);
  }
 
}
